module.exports = __webpack_public_path__ + "static/media/icon-telegram.b678d9a7.svg";